<template>
  <div>
    <div
      v-if="shelfConfig.title && !shelfConfig.noTitle && goodsList && goodsList.length"
      class="active-title fmvp-active-title"
      style="margin-top: 0.2rem"
    >
      {{ shelfConfig.title }}
    </div>
    <div v-for="(goods, index) in goodsList" :key="'goods' + index" class="fmvp-card">
      <template v-if="goods.name" style="margin-bottom: 0.06rem">
        <div class="img" @click="goToPropPage(goods, index)">
          <div v-if="goods.activityTag" class="simple-module-item-tag-box">
            <p :class="['simple-module-item-tag', goods.activityTag ? goods.tagClass : '']">
              <i>{{ goods.activityTag }}</i>
            </p>
          </div>
          <img v-lazy="goods.icon" :alt="goods.name" :onerror="placeholderBg" style="width: 1.2rem; height: 1.2rem" />
        </div>
        <div class="con">
          <div>
            <div class="name-box">
              <p class="name">
                {{ goods.name }}
              </p>
              <div v-if="giftCardNums && giftCardNumTag(goods)" class="tag-lists">
                <div class="tag-item tag-item-orange">已拥有{{ giftCardNumTag(goods) }}张</div>
              </div>
            </div>
            <div class="tag-lists">
              <div v-if="goods.tag" class="tag-item tag-item-orange">{{ goods.tag }}</div>
              <p v-if="goods.countdownTime" class="time" :style="{ marginLeft: goods.tag ? '0.06rem' : 0 }">
                {{ calTimeCountDown(goods) }}
              </p>
            </div>
            <span class="txt">{{ goods.remark }}</span>
          </div>
          <div class="go-btn">
            <div class="price">
              <p
                class="icon-ticket"
                :style="{
                  background: gameCoinIcon ? 'url(' + gameCoinIcon + ') left top / auto 100% no-repeat' : '',
                  display: goods.showGameCoinPrice && salePriceDisplay(goods) ? 'inline-block' : 'none'
                }"
              ></p>
              <span style="color: #ff1a1a">{{ salePriceDisplay(goods) }}</span>
              <i v-if="totalPriceDisplay(goods)" class="old">{{ totalPriceDisplay(goods) }}</i>
            </div>
            <div class="buy-btn" @click="goToPropPage(goods, index)">{{ buyBtnText(goods) }}</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, computed } from "@vue/composition-api"
import { checkPropCanBuy } from "@api/gameProps"
import * as reportDict from "@constants/report-dictonary"
import useDetailItem from "../../mixins/useDetailItem"
import * as langs from "@constants/langs.js"

export default {
  props: {
    shelfConfig: Object,
    routeQuery: [Object, undefined]
  },

  setup(props, { root }) {
    const { goToPropDetail } = useDetailItem(root)
    const state = reactive({
      placeholderBg: require("../../../../ui/assets/mobile/images/placeholder-bg.png"),
      vmallConfigByAMSID: computed(() => root.$store.getters.vmallConfigByAMSID),
      gameCoinIcon: computed(() => {
        return root.$store.getters?.currentItem?.gameCoinIcon || ""
      }),
      goodsList: computed(() => {
        if (props.shelfConfig?.products?.length) {
          return props.shelfConfig.products
        } else if (Array.isArray(props.shelfConfig.productId)) {
          let goodsInfoList = []
          props.shelfConfig.productId.map(productId => {
            //判断道具是否可售卖,不可售卖不展示
            if (productId && state.vmallConfigByAMSID[productId] && checkPropCanBuy(state.vmallConfigByAMSID[productId])) {
              goodsInfoList.push(state.vmallConfigByAMSID[productId])
            }
          })
          return goodsInfoList
        } else {
          let goodsInfo = {}
          if (
            props.shelfConfig.productId &&
            state.vmallConfigByAMSID[props.shelfConfig.productId] &&
            checkPropCanBuy(state.vmallConfigByAMSID[props.shelfConfig.productId])
          ) {
            goodsInfo = state.vmallConfigByAMSID[props.shelfConfig.productId]
          }
          return [goodsInfo]
        }
      }),
      giftCardNums: computed(() => {
        return root.$store.getters?.giftCardNums || ""
      })
    })

    const salePriceDisplay = goods => {
      if (goods.showGameCoinPrice) {
        return goods.salePrice
      } else {
        // 兼容价格为0，如果价格为0或空，则不显示￥
        return goods.saleCashRMBPrice ? `￥${goods.saleCashRMBPrice}` : ""
      }
    }

    const totalPriceDisplay = goods => {
      if (goods.totalPrice) {
        if (goods.showGameCoinPrice) {
          return `${goods.totalPrice}${goods.unit}`
        } else {
          return `￥${goods.totalCashRMBPrice}`
        }
      } else {
        return ""
      }
    }

    const calTimeCountDown = goods => {
      let endTime = new Date(goods?.countdownTime.replace(/-/g, "/")).getTime()
      let timediff = endTime - new Date().getTime()

      if (timediff > 0) {
        let days = Math.floor(timediff / (1000 * 60 * 60) / 24)
        return `剩余时间: ${days > 0 ? days + "天" : "今天结束"}`
      } else {
        return ""
      }
    }

    const goToPropPage = (prop, index) => {
      goToPropDetail({
        prop: prop,
        pfStructure: `${props.shelfConfig.keyName}_${index + 1}`,
        routeQuery: props.routeQuery || "",
        reportIformat: reportDict.CLICK.SERVICEZONE_ADS_BANNER
      })
    }

    const buyBtnText = goods => {
      return langs.GIFTCARD_AMSIDS.includes(goods?.itemExtend?.AMSID) ? "去赠送" : "去抢购"
    }
    // 礼品卡数量标签
    const giftCardNumTag = goods => {
      if (langs.GIFTCARD_AMSIDS.includes(goods?.itemExtend?.AMSID)) {
        return state.giftCardNums?.[goods?.itemExtend?.AMSID] || ""
      }
      return ""
    }

    return {
      ...toRefs(state),
      salePriceDisplay,
      totalPriceDisplay,
      calTimeCountDown,
      goToPropPage,
      buyBtnText,
      giftCardNumTag
    }
  }
}
</script>
